import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('LostPasswordApp => ');

const updateField = createAction('update form value', (fieldId, value) => ({ fieldId, value }));
const onLostPasswordPanelRequest = createAction('request lost password', formRef => ({ formRef }));
const onLostPasswordPanelSuccess = createAction('request lost password success');
const onLostPasswordPanelFailure = createAction('request lost password failure');

export default {
  onLostPasswordPanelRequest,
  onLostPasswordPanelSuccess,
  onLostPasswordPanelFailure,

  updateField,
};
